import { FcPrevious, FcNext } from "react-icons/fc";

const Paginator = ({ page, lastPage, pageChanged }) => {
  const next = () => {
    if (page < lastPage) {
      pageChanged(page + 1);
    }
  };

  const prev = () => {
    if (page > 1) {
      pageChanged(page - 1);
    }
  };

  // 🔥 Generate page numbers around current page
  const getPages = () => {
    const pages = [];
    const windowSize = 2; // how many pages before/after

    let start = Math.max(1, page - windowSize);
    let end = Math.min(lastPage, page + windowSize);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const pages = getPages();

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t bg-gray-50 dark:bg-gray-800">
      {/* LEFT: Info */}
      <span className="text-sm text-gray-600 dark:text-gray-400">
        Page <span className="font-semibold">{page}</span> of{" "}
        <span className="font-semibold">{lastPage}</span>
      </span>

      {/* RIGHT: Pagination */}
      <div className="flex items-center gap-1">
        {/* Prev */}
        <button
          onClick={prev}
          disabled={page === 1}
          className="px-2 py-1 rounded disabled:opacity-40 hover:bg-gray-200"
        >
          <FcPrevious />
        </button>

        {/* First page */}
        {pages[0] > 1 && (
          <>
            <button
              onClick={() => pageChanged(1)}
              className="px-3 py-1 rounded hover:bg-gray-200"
            >
              1
            </button>
            {pages[0] > 2 && <span className="px-2">...</span>}
          </>
        )}

        {/* Middle pages */}
        {pages.map((p) => (
          <button
            key={p}
            onClick={() => pageChanged(p)}
            className={`px-3 py-1 rounded ${
              p === page ? "bg-blue-600 text-white" : "hover:bg-gray-200"
            }`}
          >
            {p}
          </button>
        ))}

        {/* Last page */}
        {pages[pages.length - 1] < lastPage && (
          <>
            {pages[pages.length - 1] < lastPage - 1 && (
              <span className="px-2">...</span>
            )}
            <button
              onClick={() => pageChanged(lastPage)}
              className="px-3 py-1 rounded hover:bg-gray-200"
            >
              {lastPage}
            </button>
          </>
        )}

        {/* Next */}
        <button
          onClick={next}
          disabled={page === lastPage}
          className="px-2 py-1 rounded disabled:opacity-40 hover:bg-gray-200"
        >
          <FcNext />
        </button>
      </div>
    </div>
  );
};

export default Paginator;
